<template>
  <div class="row">
    <div class="col tab">
      <div class="d-flex product">
        <div class="container-fluid product-titr" v-show="services.length">
          <!-- Product Cat -->
          <Category :data="category" @getCatId="readService($event)" />
          <!-- Product Cat -->

          <div class="border col-12"></div>

          <div class="row pt-4">
            <!-- services Items -->
            <Items :items="services" />
            <!-- services Items -->

            <!-- Shopping basket -->
            <Shopping-basket :data="services" />
            <!-- Shopping basket -->
          </div>
        </div>

        <!-- Not Service -->
        <div class="container-fluid product-titr" v-show="!services.length">
          <div class="row">
            <div class="col tab">
              <div class="d-flex about">
                <div class="about-titr">
                  <h5>خدمتی ثبت نشده است.</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Not Service -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios.js";

import Category from "./components/Category";
import Items from "./components/Items";
import ShoppingBasket from "./components/ShoppingBasket";
let business = {};

export default {
  name: "Service",

  data() {
    return {
      category: {},
      services: {},
    };
  },

  components: {
    Category,
    Items,
    ShoppingBasket,
  },

  async beforeRouteEnter(t, f, n) {
    if (!localStorage.getItem("business")) {
      n({ path: `/${t.params.username}/about` });
    } else {
      business = JSON.parse(localStorage.getItem("business"));

      await axios
        .get("business/service/read_cats.php", {
          params: { business_id: business.id },
        })
        .then((d) => {
          axios
            .get("business/service/read_user.php", {
              params: {
                bid: business.id,
              },
            })
            .then((data) => {
              n((v) => {
                v.getCats(d.data);
                v.getServices(data.data);
              });
            });
        })
        .catch((err) => console.error("Response Error read Cats ::", err));
    }
  },

  methods: {
    async readService(cat) {
      let id = +cat;
      let where = {};

      if (id) {
        where = JSON.stringify([
          { table: "service_category", key: "id", value: id },
        ]);
      }

      let params = {
        bid: business.id,
        where,
      };

      await axios
        .get("business/service/read_user.php", { params })
        .then((data) => {
          this.services = data.data;
        });
    },

    getCats(d) {
      if(!Array.isArray(d) || Object.keys(d).length === 0) return;
      d.unshift({
        id: "0",
        title: "همه",
        description: "",
        img_url: "",
        bg_color: "",
        parent_id: "0",
        product_id: "871",
      });

      this.category = d;
    },

    getServices(items) {
      this.services = items;
      console.log("services:", this.services);
    },
  },
};
</script>